/**
 * Uplifted from `helper/paymentKey.ts` — the file exists in BOTH apps, one export each.
 *
 * The two maps agree on **10 keys, byte-identical**; web has an eleventh, `bonushubedc`. So
 * the common ten live here and each variant composes the map it needs — web spreads this and
 * adds its key, mobile aliases it (see the two `index.*` files).
 *
 * Safe to split this way because **no consumer iterates the map** — grepped across both apps,
 * all 12 call sites are `paymnetsKeyMapping[mode]` with a fallback to the raw mode string. Key
 * order and the presence of an extra key therefore change nothing but the lookup table.
 *
 * ⚠️ `paymnetsKeyMapping` is misspelled (`paymnets`) in both apps and in all 12 consumers.
 * Kept verbatim — renaming it is a consumer change, not an uplift.
 */
export const SHARED_PAYMENT_KEY_MAPPING: Record<string, string> = {
  paytmedc: "Paytm EDC",
  paytmqr: "Paytm QR",
  paytmqdqr: "Paytm DQR",
  razorpay: "Razorpay",
  pinelabs: "Pine labs",
  "pine-lab": "Pine Labs",
  paytmdqr: "Paytm DQR",
  phonepeupi: "PhonePe DQR",
  qwikcilver: "Qwikcilver",
  phonepedqr: "PhonePe DDQR",
};

/**
 * `getPaymentModeLabel` arrived with the customer display (release_4.0.0) against a flat
 * `helpers/paymentKey.ts` that duplicated this folder. The lookup table is per-platform, so the
 * LOGIC lives here once and each variant binds it to its own map — one definition, two bindings.
 */
export const createPaymentModeLabel =
  (mapping: Record<string, string>) =>
  (mode: string | undefined): string =>
    mode ? mapping[mode] || mode : "";
